import { Endpoint } from '../endpoint';
import { SenderResponse, SenderID } from '@business/entities/sender';

export function fetchSenders() {
  return Endpoint.get<SenderResponse[]>(`@gc/senders`);
}

export function createSender(data: Partial<SenderResponse>) {
  return Endpoint.post<SenderResponse>(`@gc/senders`, { data });
}

export function updateSender(id: SenderID, data: Partial<SenderResponse>) {
  return Endpoint.patch<SenderResponse>(`@gc/senders/${id}`, { data });
}

export function makeDefault(id: SenderID) {
  return Endpoint.patch<SenderResponse[]>(`@gc/senders/default/${id}`);
}

export function deleteSender(id: SenderID) {
  return Endpoint.delete<void>(`@gc/senders/${id}`);
}
